import { reducer as form } from 'redux-form';
import { routerReducer as routing } from 'react-router-redux'
import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import client from './reducers/client/';
import language from './reducers/language/';
import clientproduct from './reducers/clientproduct/';
import product from './reducers/product/';
import authReducer from './reducers/auth/';
import productoption from './reducers/productoption/';
import clientproductstyle from './reducers/clientproductstyle/';
import clientproductoption from './reducers/clientproductoption/';


const store = createStore(
  combineReducers({authReducer, routing, form, client, language, clientproduct, product, productoption, clientproductstyle, clientproductoption}), // Don't forget to register the reducers here
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(thunk),
);


export default store;


// WEBPACK FOOTER //
// ./src/store.js